import * as React from "react";

export default class BtnCancelar extends React.Component {
    onClickCancelar() {
        this.props.onClick();
    }

    render() {
        return <button
            type={this.props.type}
            className={(this.props.isLoading) ? "btn btn-dark" : "btn btn-lightred"}
            disabled={this.props.isLoading ? true : false}
            onClick={this.onClickCancelar.bind(this)}
        >
            <i className="fa fa-close"></i>
            {(this.props.isLoading) ? this.props.textLoading : this.props.text}
        </button>;
    }
}